<template>
  <div class="write_box">
    <div class="write_title mb20"></div>
    <table class="Info_table">
      <tr>
        <td class="td_title">아이디</td>
        <td colspan="2" class="td_content">
          <el-input class="middle" type="text" v-model="id" @input="initCheckData('id', id)" @blur="checkIdDuplicate()"></el-input>
          <div class="input_error" v-if="validation.hasError('id')">{{ validation.firstError('id') }}</div>
          <div class="input_error" v-else-if="validation.hasError('idCheckDuplicate')">{{ validation.firstError('idCheckDuplicate') }}</div>
          <div class="input_error" v-else-if="idCheckDuplicate">사용가능한 아이디입니다.</div>
        </td>
        <td class="td_title">닉네임</td>
        <td colspan="2" class="td_content">
          <el-input class="middle" type="text" v-model="nick" maxLength="10" @input="initCheckData('nick', nick)" @blur="checkNickDuplicate()"></el-input>
          <div class="input_error" v-if="validation.hasError('nick')">{{ validation.firstError('nick') }}</div>
          <div class="input_error" v-else-if="validation.hasError('nickCheckDuplicate')">{{ validation.firstError('nickCheckDuplicate') }}</div>
          <div class="input_error" v-else-if="nickCheckDuplicate">사용가능한 닉네임입니다.</div>
        </td>
      </tr>
      <tr>
        <td class="td_title">이름</td>
        <td colspan="2" class="td_content"></td>
        <td class="td_title">생년월일</td>
        <td colspan="2" class="td_content"></td>
      </tr>
      <tr>
        <td class="td_title">비밀번호</td>
        <td colspan="2" class="td_content">
          <el-input class="middle" type="password" v-model="password" maxLength="20" @input="setPassword('password', password)"></el-input>
          <div class="input_error" v-if="validation.hasError('password')">{{ validation.firstError('password') }}</div>
        </td>
        <td class="td_title">비밀번호 확인</td>
        <td colspan="2" class="td_content">
          <el-input class="middle" type="password" v-model="passwordConfirm" @input="setPassword('passwordConfirm', passwordConfirm)"></el-input>
          <div class="input_error" v-if="validation.hasError('passwordConfirm')">{{ validation.firstError('passwordConfirm') }}</div>
        </td>
      </tr>
      <tr>
        <td class="td_title">전화번호</td>
        <td colspan="2" class="td_content">
<!--          <el-input class="middle" type="tel" oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1');" maxlength="11" @input="initCheckData('phone', phone)" @blur="checkPhoneDuplicate()"></el-input>-->
<!--          <div class="input_error" v-if="validation.hasError('phone')">{{ validation.firstError('phone') }}</div>-->
<!--          <div class="input_error" v-else-if="validation.hasError('phoneCheckDuplicate')">{{ validation.firstError('phoneCheckDuplicate') }}</div>-->
<!--          <div class="input_error" v-else-if="phoneCheckDuplicate && memberData.mb_hp != phone">사용가능한 전화번호입니다.</div>-->
        </td>
        <td class="td_title">상태</td>
        <td colspan="2" class="td_content"></td>
      </tr>
      <tr>
        <td class="td_title">프로필 썸네일 / 프로필 배경</td>
        <td colspan="2" class="td_content">
          <!--          <el-upload-->
          <!--              class="img_inputBox_wrap"-->
          <!--              action=""-->
          <!--              list-type="picture"-->
          <!--              :thumbnail-mode="true"-->
          <!--              :show-file-list="false"-->
          <!--              :auto-upload="false"-->
          <!--              :on-change="onlyOneFileUpload"-->
          <!--          >-->
          <!--            <img v-if="checkImg(child)" :src="returnImg(child)" class="avatar">-->
          <!--            <div class="img_inputBox" v-else></div>-->
          <!--            &lt;!&ndash;                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>&ndash;&gt;-->
          <!--          </el-upload>-->
        </td>
        <td class="td_title">프로필 배너</td>
        <td colspan="2" class="td_content"></td>
      </tr>
      <tr>
        <td class="td_title">유형</td>
        <td colspan="2" class="td_content"></td>
        <td class="td_title">추천인 아이디</td>
        <td colspan="2" class="td_content"></td>
      </tr>
      <tr>
        <td class="td_title">큐레이터</td>
        <td colspan="2" class="td_content"></td>
        <td class="td_title">큐레이터 증빙자료</td>
        <td colspan="2" class="td_content"></td>
      </tr>
      <tr>
        <td class="td_title">계좌</td>
        <td colspan="2" class="td_content"></td>
        <td class="td_title">밍글</td>
        <td colspan="2" class="td_content"></td>
      </tr>
      <tr>
        <td class="td_title">SNS</td>
        <td colspan="4" class="td_content">
<!--          <el-input class="snsInput mb10" type="text"></el-input>-->
<!--          <el-input class="snsInput mb10" type="text"></el-input>-->
<!--          <el-input class="snsInput" type="text"></el-input>-->
        </td>
      </tr>
      <tr>
        <td class="td_title">자기소개</td>
        <td colspan="4" class="td_content">
          <div class="introduce_box">
<!--            <el-input type="textarea"></el-input>-->
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import memberValidator from "@/mixins/validators/memberValidator";
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";

export default {
  name: "MemberWriteCreateLayout",
  mixins: [memberValidator],
  components: {
  },
  inject: ['memberWriteSetData'],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    EventBus.$on('MemberWriteCreateLayoutValidator', this.checkAllValidator)
  },
  beforeDestroy() {
    EventBus.$off('MemberWriteCreateLayoutValidator');
  },
  destroyed() {},
  computed: {
  },
  methods:{
    setData(type, value) {
      this[type] = value;
      this.hasError = false;
    },
    initCheckData(type, value) {
      this.setParentData(type, value);
      this[`${type}CheckDuplicate`] = false;
      this[`${type}Duplicate`] = false;
      this.$validate([`${type}CheckDuplicate`])
      this.setParentData(`${type}CheckDuplicate`, this[`${type}CheckDuplicate`]);
      this.setParentData(`${type}Duplicate`, this[`${type}Duplicate`]);
    },
    setParentData(type, value) {
      if(!util.isEmpty(this.memberWriteSetData) && util.isFunction(this.memberWriteSetData)) {
        this.memberWriteSetData(type, value);
      }
    },
    setPassword(type, value) {
      this.setParentData(type, value);
      if(this.passwordConfirm != '') {
        this.$validate([`passwordConfirm`]);
      }
    },
    checkIdAfter(type) {
      if(type === 1) {
        this.idCheckDuplicate = true;
        this.idDuplicate = false;
      }else{
        this.idCheckDuplicate = false;
        this.idDuplicate = true;
      }
      this.$validate(['idCheckDuplicate'])
      this.setParentData('idCheckDuplicate', this.idCheckDuplicate)
      this.setParentData('idDuplicate', this.idDuplicate)
    },
    checkNickAfter(type) {
      if(type === 1) {
        this.nickCheckDuplicate = true;
        this.nickDuplicate = false;
      }else{
        this.nickCheckDuplicate = false;
        this.nickDuplicate = true;
      }
      this.$validate(['nickCheckDuplicate'])
      this.setParentData('nickCheckDuplicate', this.nickCheckDuplicate)
      this.setParentData('nickDuplicate', this.nickDuplicate)
    },
    checkAllValidator() {
      this.$validate(['id', 'idCheckDuplicate', 'nick', 'nickCheckDuplicate', 'password',]);
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>